<template>
    <div class="login-box">
        <base-header></base-header>
        <!-- 用户名密码登录 -->
        <div class="part part1" v-if="type == 1">
            <base-input :title="`平台账号：`" v-model="passname" @blur="checkPassName" :placeholder="`请输入手机号或邮箱`" class="input-box"></base-input>
            <base-input :title="`平台密码：`" v-model="password" :placeholder="`请输入密码`" :type="`password`" class="input-box"></base-input>
            <div class="login-err">{{err}}</div>
            <base-button :name="`登录绑定`" class="login-btn" @click="login"></base-button>
            <h2>
                <span @click="err='';step=1;type=2">切换为手机验证码登录/注册</span>
            </h2>
        </div>
        <div class="part part2" v-else>
            <div class="step" v-if="step == 1">
                <base-input :title="`手机号：`" v-model="account" @blur="checkAccount" :placeholder="`请输入手机号`" class="input-box"></base-input>
            </div>
            <div class="step" v-else-if="step == 2">
                <base-input :title="`手机号：`" v-model="account" :readonly="is_read_only" class="input-box"></base-input>
                <div id="captcha" v-if="step == 2 && captchaType == 'xn'"></div>
                <div id="captcha" v-if="step == 2 && captchaType == 'yz'" class="captcha-content"></div>
                <div v-if="step == 2 && captchaType == 'yz'" :class="['yzBtn', yzover ? 'over' : '']"></div>
                <h2>
                    <span @click="handleCopyContent(106901639999)">复制短信目标号码</span>
                </h2>
            </div>
            <div class="step" v-else-if="step == 3">
                <base-input :title="`手机号：`" v-model="account" :readonly="is_read_only" class="input-box"></base-input>

                <div class="send-box">
                    <base-input :title="`验证码：`" ref="inputRef" v-model="code"  @input="changeCode($event)" :placeholder="`请输入手机验证码`" class="input-box"></base-input>
                    <base-button :name="send_btn_name" class="btn-send" @click="getCode" :wd="`1.8rem`" :ht="`.8rem`" :fz="`.26rem`"></base-button>
                </div>
            </div>
            <div class="step" v-else-if="step == 4">
                <base-input :title="`手机号：`" v-model="account" :readonly="is_read_only" class="input-box"></base-input>
                <!-- <div class="tips-new">检测到该账号并未注册，补充以下信息快速注册</div> -->
                <base-input :title="`平台昵称：`" style="margin-top: .2rem" v-model="nickname" @blur="checkNickname" :placeholder="`请输入平台昵称`" class="input-box"></base-input>
                <base-input :title="`真实姓名：`" v-model="realname" @blur="checkRealName" :placeholder="`请输入真实姓名`" class="input-box"></base-input>
                <base-input :title="`身份证号：`" v-model="idcard" @blur="checkIdcard" :placeholder="`请输入身份证号码`" class="input-box"></base-input>
            </div>
            <!-- // 1输手机号 2虚拟 3收码 4补全信息 -->
            <div class="login-err">{{err}}</div>
            <base-button :name="`下一步`" class="next-btn" @click="toNext" v-if="step == 1 || step == 2 || (step == 3 && !is_exist)"></base-button>
            <base-button :name="`确定`" class="sure-btn" @click="reg" v-else-if="step == 3 && is_exist"></base-button>
            <base-button :name="`快速注册`" class="sure-btn" @click="register" v-else-if="step == 4"></base-button>
            <div class="tips-new" style="margin-top: .2rem" v-if="step==4">检测到该账号并未注册，补充以下信息快速注册</div>
            <div class="tips-new" style="margin-top: 0" v-if="step==4">身份证号是您账户找回的唯一凭证，请准确填写谢谢配合。</div>
            <h2>
                <span @click="err=''; type=1">切换为平台账号密码登录</span>
            </h2>
        </div>
        <div class="rules" v-if="type == 1 || (type ==2 && (step == 4 || step == 3 && is_exist))">
            <div :class="`tick ${is_agree?'ticked':''}`" @click="is_agree = !is_agree"></div>
            <p>
                已阅读并同意
                <span @click="read_rules(1)">用户条例</span> &
                <span @click="read_rules(2)">使用协议</span>
            </p>
        </div>
        <base-rules ref="rulesRef"></base-rules>
        <base-agree ref="agreeRef"></base-agree>
    </div>
</template>
<script>
import { hex_md5 } from '@/utils/md5'
import { baseUrls } from '@/utils/baseUrlConfig'
import {getNewCode, sendCode , SecureSedNote} from "../utils/req";
const base_url = baseUrls.user_url
var captchaIns = null
export default {
    name: 'login',
    data() {
        return {
            type: 1, //1账号密码  2验证码登录
            account: '',
            passname: '',
            password: '',
            captchaIns: null,
            checkId: '',
            code: '', //验证码
            is_read: true,
            captchaType: '',
            val: '',
            activeNames: ['1'],
            square_icon: require('@/assets/img/square.png'),
            isActive: false,
            err: '',
            btn_lock: false,
            send_btn_lock: false,
            code_check_id: '',
            send_btn_name: '发送验证码',
            send_timer: null,
            send_count: 60,
            open_id: '',
            m_key: '',
            realname: '', //真实姓名
            idcard: '', //身份证
            nickname: '', //平台昵称
            dun_check_id: '',
            is_virtual: false,
            is_exist: true,
            step: 3, //2虚拟 3收码 4补全信息
            is_read_only: true,
            is_agree: false, //是否同意规则
            fromPage: this.$route.query.fromPage,
            yzover:false
        }
    },
    mounted() {

    },
    created() {
        this.open_id = this.$storage.getOpenId()
        this.m_key = this.$storage.getmKey()

    },
    methods: {
        jumpToPage(res) {
            if (this.fromPage && this.fromPage != '') {
                if(this.fromPage.indexOf('http') > -1){
                    // 外部地址
                    window.location.replace(this.$common.setUrlQuery({url: decodeURIComponent(this.fromPage), query:{token: res.token}}));
                    // window.location.replace(decodeURIComponent(this.fromPage) + '?token=' + (res ? res.token : null));
                } else{
                    this.$router.push(this.fromPage)
                }
            } else {
                this.$router.push('/')
            }
        },
        // 绑定微信
        bindWeChat() {
            this.passname = this.passname.trim()
            this.password = this.password.trim()
            this.$http.bindUserWechat(this.m_key, this.open_id, this.passname, this.password).then((res) => {
                if (res.result == 0) {
                    //绑定成功
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    this.jumpToPage(res)
                } else {
                    this.$message.error(res.err ? res.err : '微信绑定失败，请联系平台客服')
                }
            })
        },
        handleChange(val) {
            console.log(val)
        },
        read_rules(type) {
            if (type == 1) {
                this.$refs.rulesRef.openPop()
            } else if (type == 2) {
                this.$refs.agreeRef.openPop()
            }
        },
        // 登录绑定
        login() {
            if (this.btn_lock) {
                return false
            }
            this.passname = this.passname.trim()
            this.password = this.password.trim()

            if (this.passname == '') {
                this.err = '登录账号不能为空'
                return false
            }
            if (this.password == '') {
                this.err = '密码不能为空'
                return false
            }
            if (!this.is_agree) {
                this.$message.error('请阅读并同意用户条例及使用协议')
                return false
            }
            let password = hex_md5('SIYOU#@!' + this.password + "/'[}*&^%")
            //登录
            this.btn_lock = true
            this.$http.userHttpLogin(this.passname, password).then((res) => {
                if (res.result == 0) {
                    //登录成功
                    this.btn_lock = false
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    this.bindWeChat() //绑定微信
                } else {
                    this.btn_lock = false
                    this.err = res.err ? res.err : res.error_msg ? res.error_msg : '登录失败，请联系管理员！'
                }
            })
        },
        changeCode(val) {
            this.$nextTick(() => {
                if (val.length > 6) {
                    this.code = val.slice(0, 6)
                }
            })
        },
        toNext() {
            if (this.type == 2) {
                if (this.step == 1) {
                    if (!this.checkAccount()) return false
                    if (!this.is_exist && this.cheackVirtualPhone(this.account)) {
                        // 虚拟号段
                        this.step = 2
                        this.captchaType = 'xn'
                        this.initDunPic(this.account)
                    } else {
                      this.step = 2
                      this.captchaType = 'yz'
                      this.initNECaptcha()
                    }
                } else if (this.step == 2) {
                    if (this.dun_check_id == '') {
                        return false
                    }
                    this.step = 4
                } else if (this.step == 3 && !this.is_exist) {
                    if(!this.checkCode()){
                        return false
                    }
                    this.step = 4
                }
            }
        },
        // 注册并绑定
        register() {
            if (this.btn_lock) {
                return false
            }
            if (!this.checkAccount()) {
                return false
            }
            if (!this.checkNickname()) {
                return false
            }
            if (!this.checkRealName()) {
                return false
            }
            if (!this.checkIdcard()) {
                return false
            }
            if (!this.is_agree) {
                this.$message.error('请阅读并同意用户条例及使用协议')
                return false
            }
            //登录
            this.btn_lock = true
            this.$http
                .userRegisterByWx(
                    this.m_key,
                    this.account,
                    this.code_check_id,
                    this.open_id,
                    this.nickname,
                    this.realname,
                    this.idcard,
                    this.dun_check_id
                )
                .then((res) => {
                    if (res.code == 0) {
                        //注册绑定成功
                        this.btn_lock = false
                        this.$storage.setAuth(res.token)
                        this.$storage.setToken(res.token)
                        this.jumpToPage(res)
                    } else {
                        this.btn_lock = false
                        this.err = res.err ? res.err : res.error_msg ? res.error_msg : '登录失败，请联系管理员！'
                    }
                })
        },
        // 验证码登录
        reg() {
            if (this.btn_lock) {
                return false
            }
            this.account = this.account.trim()
            this.code = this.code.trim()

            if (this.account == '') {
                this.err = '账号不能为空'
                return false
            }
            if (this.code == '') {
                this.err = '验证码不能为空'
                return false
            }
            if (!this.is_agree) {
                this.$message.error('请阅读并同意用户条例及使用协议')
                return false
            }
            if(!this.checkCode()){
                return false
            }
            //登录
            this.btn_lock = true

            this.$http.userMobileLogin(this.m_key, this.account, this.code_check_id, this.open_id).then((res) => {
                if (res.result == 0) {
                    //登录成功
                    this.btn_lock = false
                    this.$storage.setAuth(res.token)
                    this.$storage.setToken(res.token)
                    this.jumpToPage(res)
                } else {
                    this.btn_lock = false
                    this.err = res.err ? res.err : res.error_msg ? res.error_msg : '登录失败，请联系管理员！'
                }
            })
        },
        cheackVirtualPhone(value) {
            if (/^(162|165|167|170|171|192)\d{8}$/.test(value)) {
                // 虚拟号段
                this.is_virtual = true
                return true
            } else {
                // 非虚拟号段
                this.is_virtual = false
                return false
            }
        },
        checkRealName() {
            this.realname = this.realname.trim()
            var flag = false
            if (!/^[\u4e00-\u9fa5]{1,7}(·[\u4e00-\u9fa5]{1,7}){0,2}$/.test(this.realname)) {
                this.err = '请填写正确的姓名！'
            } else {
                this.err = ''
                flag = true
            }
            return flag
        },
        checkIdcard() {
            this.idcard = this.idcard.trim()
            var flag = false
            if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(this.idcard)) {
                this.err = '请填写正确的身份证号码！'
            } else {
                flag = true
                this.err = ''
            }
            return flag
        },
        handleCopyContent(content) {
            var input = document.createElement('input') // 创建input对象
            input.value = content // 设置复制内容
            document.body.appendChild(input) // 添加临时实例
            input.select() // 选择实例内容
            document.execCommand('Copy') // 执行复制
            document.body.removeChild(input) // 删除临时实例
            this.$message.success('已将短信目标号码复制到剪切板！')
        },
        checkNickname() {
            this.err = ''
            this.nickname = this.nickname.trim()
            if (this.nickname == '') {
                this.err = '用户昵称不能为空'
                return false
            }
            if (this.nickname.length < 2 || this.nickname.length > 8) {
                this.err = '用户昵称在5个汉字或8个字符长度'
                return false
            }
            var totalLength = 0
            /* 计算utf-8编码情况下的字符串长度 */
            for (let i = 0; i < this.nickname.length; i++) {
                if (this.nickname.charCodeAt(i) <= parseInt('0x7F')) {
                    totalLength += 1
                } else if (this.nickname.charCodeAt(i) <= parseInt('0x7FF')) {
                    totalLength += 2
                } else if (this.nickname.charCodeAt(i) <= parseInt('0xFFFF')) {
                    totalLength += 3
                } else if (this.nickname.charCodeAt(i) <= parseInt('0x1FFFFF')) {
                    totalLength += 4
                } else if (this.nickname.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
                    totalLength += 5
                } else {
                    totalLength += 6
                }
            }
            if (totalLength > 15) {
                this.err = '超过最大字符长度！'
                return false
            }
            if (!/^[\u4e00-\u9fa5\_\丶a-zA-Z0-9]+$/.test(this.nickname)) {
                //特殊字符（只可以有这两项）	"丶"，"_"
                this.err = '用户昵称不支持特殊字符'
                return false
            }
            var flag = false
            $.ajax({
                url: base_url + '/GetNameExist?user_name=' + this.nickname,
                async: false,
                success: (res) => {
                    if (res.code != 0) {
                        this.err = res.err ? res.err : '此用户名已存在'
                    } else {
                        flag = true
                        this.err = ''
                    }
                },
            })
            return flag
        },
        checkAccount() {
            this.err = ''
            this.account = this.account.trim()
            if (this.account == '') {
                this.err = '请填写手机号！'
                return false
            }
            if (!this.checkPhone(this.account)) {
                return false
            }
            $.ajax({
                url: base_url + '/GetAllUserV1?type=1&userInfo=' + this.account, //校验手机号是否可用
                async: false,
                success: (res) => {
                    if (res.result == 0 && res.count > 0) {
                        this.is_exist = true
                    } else {
                        this.is_exist = false
                    }
                },
            })
            return true
        },
        initDunPic(phone) {
            let _this = this
            initNECaptcha(
                {
                    captchaId: 'f02091bb25be490ab7ad2c4226d2c5cc',
                    element: '#captcha',
                    mode: 'embed',
                    width: '320px',
                    onVerify: function (err, data) {
                        if (err) return // 当验证失败时，内部会自动refresh方法，无需手动再调用一次

                        // console.log('验证通过', data);
                        $.ajax({
                            url: `${base_url}/VerifyV1`,
                            data: { validate: data.validate, phone: phone },
                            success: (res) => {
                                if (res.code == 0) {
                                    _this.dun_check_id = res.check_id
                                } else {
                                    _this.dun_check_id = ''
                                    _this.err = res.msg ? res.msg : '验证失败，请重试！'
                                    captchaIns && captchaIns.refresh()
                                }
                            },
                        })
                    },
                },
                function onload(instance) {
                    captchaIns = instance
                },
                function onerror(err) {
                    console.warn(err)
                }
            )
        },
      // 初始化网易云盾
      initNECaptcha() {
        const _this = this
        initNECaptchaWithFallback({
          captchaId: '68c9222ddacd4d64805db2602562b66c',
          element: '#captcha',
          mode: 'popup',
          width: '300px',
          apiVersion: 2,
          popupStyles: {
            position: 'fixed',
            top: '20%',
          },
          onVerify: function (err, data) {
            // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
            if (err) return
            captchaIns.destroy()
            // 若成功拿到 validate，可向后端发送请求
            _this.getNewCode(data.validate)
          }
        }, function onload(instance) {
            captchaIns = instance
            document.querySelector('.yzBtn').addEventListener('click', function () {
                if(_this.checkId){
                    return
                }
                captchaIns && captchaIns.verify()
            })
        }, function onerror(err) {
          console.warn(err)
        })
      },
      // 网易云盾code验证
      getNewCode(code) {
        $.ajax({
          url: base_url + `/NewCodeV1`,
          type: 'POST',
          data: { NECaptchaValidate: code },
          async: false,
          success: (res) => {
            if (res.code == 0) {
              this.checkId = res.check_id
              this.step = 3
              this.yzover = true
            } else {
              this.yzover = true
              this.err = res.error? res.error : '验证码有误请重新输入！'
              captchaIns && captchaIns.refresh()
            }
          }
        })
      },
        // 获取短信验证码
        getCode() {
            this.err = ''
            if (this.send_btn_lock) {
                this.err = '验证码已发送，请稍等！'
                return false
            }
            if (!this.checkPhone()) return false
            this.send_btn_lock = true
            this.$http.SecureSedNote(this.account, this.checkId).then((res) => {
                if (res.code == 0) {
                    this.code_check_id = res.check_id
                    this.$nextTick(() => {
                        this.$refs.inputRef.focusInput()
                    })
                    this.send_btn_name = '请稍等(' + this.send_count + ')'
                    this.send_timer = setInterval(() => {
                        this.send_count--
                        if (this.send_count == 0) {
                            this.send_btn_lock = false
                            this.send_btn_name = '重新发送'
                            this.send_count = 60
                            clearInterval(this.send_timer)
                        } else {
                            this.send_btn_name = '请稍等(' + this.send_count + ')'
                        }
                    }, 1000)
                } else {
                    this.err = res.error ? res.error : '发送失败'
                    this.send_btn_lock = false
                }
            })
        },
        // 校验手机验证码
        checkCode() {
            this.err = ''
            this.account = this.account.trim()
            this.code = this.code.trim()
            if (this.code == '') {
                this.err = '请填写验证码！'
                return false
            }
            let flag = false
            $.ajax({
                url: base_url + '/VerificationNoteV1?phoneNumber=' + this.account + '&code=' + this.code + '&check_id=' + this.code_check_id,
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        this.code_check_id = res.check_id
                        flag = true
                    } else {
                        this.err = res.error? res.error : '验证码有误请重新输入！'
                    }
                },
            })
            return flag
        },
        // 校验手机号格式
        checkPhone() {
            this.err = ''
            this.account = this.account.trim()
            // console.log(this.account)
            if (this.account == '') {
                this.err = '请填写手机号！'
                return false
            }
            if (this.account.length != 11 || !/^1[3456789][0-9]{9}$/.test(this.account)) {
                this.err = '请填写正确的手机号！'
                return false
            }
            return true
        },
        // 校验登录账号是否为空
        checkPassName() {
            this.err = ''
            this.passname = this.passname.trim()
            if (this.passname == '') {
                this.err = '请填写手机号或邮箱！'
                return false
            }
            return true
        },
    },
}
</script>
<style lang="scss" scoped>
.login-box {
    .input-box {
        margin-top: 0.32rem;
    }
    .login-btn {
        margin-top: 0.2rem;
    }
    .tips-new {
        width: 100%;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: center;
        margin: 0 auto;
        color: #ff0000;
        font-size: 0.22rem;
    }
    .login-err {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        padding-left: 2.54rem;
        text-align: left;
        margin: 0 auto;
        color: #ff0000;
        font-size: 0.22rem;
    }
    h2 {
        font-size: 0.26rem;
        color: #2f92eb;
        text-align: center;
        text-decoration: underline;
        padding-top: 0.4rem;
        &:hover {
            cursor: pointer;
            color: #00427e;
        }
    }
    .send-box {
        position: relative;
        width: 6.22rem;
        margin: 0 auto;
        .btn-send {
            position: absolute;
            top: 50%;
            right: 0.11rem;
            transform: translateY(-50%);
        }
    }
    .rules {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 0.34rem;
        line-height: 0.34rem;
        margin-top: 0.5rem;
        p {
            font-size: 0.24rem;
            color: #c39b5e;
            height: 0.34rem;
            line-height: 0.34rem;
            padding-bottom: 0.5rem;
            span {
                color: #2f92eb;
                text-decoration: underline;
                padding: 0 0.03rem;
                &:hover {
                    cursor: pointer;
                    color: #00427e;
                }
            }
        }

        .tick {
            width: 0.34rem;
            height: 0.34rem;
            background: url(~@/assets/img/pick.png) 0 0 no-repeat;
            background-size: 100% auto;
            margin-right: 0.2rem;

            &.ticked {
                cursor: default;
                background-position-y: -0.34rem;
            }
        }
    }
}
.yzBtn {
  margin-left: 0.5rem;
  width: 6.5rem;
  height: .71rem;
  background: url(~@/assets/img/yz.png)no-repeat 0 0;
  background-size: cover;
}
.yzBtn:hover {
  cursor: pointer;
  margin-left: 0.5rem;
  width: 6.5rem;
  height: .71rem;
  background: url(~@/assets/img/yzH.png) 0 0 no-repeat;
  background-size: cover;
}
.yzBtn:active {
  margin-left: 0.5rem;
  width: 6.5rem;
  height: .71rem;
  background: url(~@/assets/img/yzA.png) 0 0 no-repeat;
  background-size: cover;
}
.yzBtn.over {
  cursor: auto;
  margin-left: 0.5rem;
  width: 6.5rem;
  height: .71rem;
  background: url(~@/assets/img/yzOver.png) 0 0 no-repeat;
  background-size: cover;
}
</style>
<style>
  .captcha-content .yidun_intellisense {
    width: 6rem;
    margin: 0 auto;
  }
  .captcha-content .yidun_intellisense--light .yidun_intelli-control {
    background: linear-gradient(0deg, #c4a160, #6f542b);
    border-radius: 1rem;
  }
  .captcha-content .yidun_intellisense--light .yidun_intelli-tips {
    color: #ffffff;
  }
</style>




// WEBPACK FOOTER //
// src/view/login.vue